<template>
  <div>
    <b-card-body>
      <b-card class="loadContainer">
        <b-form>
          <b-row>
            <b-col sm="12">
              <div>
                <div class="row">
                  <div class="
                      col-12
                      table-responsive-md table-wrapper-scroll-y
                      my-custom-scrollbar
                    ">
                    <table class="table table-hover table-sm">
                      <thead class="thead-dark">
                        <th scope="col">{{ $t('importSelectArea') }}</th>
                      </thead>
                      <tbody class="">
                        <template>
                          <tr v-for="flow in this.areas" :key="flow.area">
                            <td @click="selectedArea(flow.area)" class="text-truncate tableTxt" style="max-width: 100px">
                              {{ flow.area }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="rowDistance">
                <div class="text-truncate tableTxt" style="max-width: 370px">
                  <b>{{ $t('importExportSelected') }}: </b>{{ this.areaSelected }}
                </div>
              </div>
              <div class="mt-4"
                v-if="user.Permissions.efetuarplanejamentoproducao && user.Permissions.efetuarplanejamentoproducao.allowed && user.Permissions.efetuarplanejamentoproducao.permission">
                <b-form-radio-group id="radio-group-1" v-model="type" :options="options"
                  name="radio-options"></b-form-radio-group>
              </div>
              <br />
            </b-col>
          </b-row>

          <b-row class="groupBtn">
            <div>
              <label for="inputImport">
                <img src="@/assets/importar.png" style="margin-left: 20px" :title="$t('import')" alt="Importar" />
              </label>
              <input id="inputImport" type="file" ref="myFile" accept="application/json" @change="selectedFile" />
              <img src="@/assets/exportar.png" style="margin-left: 20px" :title="$t('export')" alt="Exportar"
                @click="exportArea" />
              <img id="closeModalPassword" class="float-right" src="@/assets/sair.png"
                style="margin-left: 15px; margin-right: 20px" :title="$t('exit')" alt="Sair" @click="closeImportExport" />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import { saveAs } from "file-saver";
import { SingletonFlowchart } from "../flowchart/nodes/_service/singletonFlowchart";
import { SingletonAreas } from "../flowchart/nodes/_service/singletonAreas";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "ImportExport",
  props: ["areas"],

  computed: mapState(["user"]),

  data() {
    return {
      areaSelected: "",
      type: "PAP",
      options: [
        { text: 'PAP', value: 'PAP' },
        { text: 'PCP', value: 'PCP' }
      ]
    }
  },

  watch: {
    areaSelected(value) {
      if (value)
        defaultSuccess(this.$t('area') + `${value}` + this.$t('selecionada'));
    },

    fileName(newTxt) {
      this.fileName = this.txtLimits(newTxt);
    },
  },

  methods: {
    selectedFile() {
      let file = this.$refs.myFile.files[0];

      if (!file || file.type != "application/json") {
        showError(this.$t('o-arquivo-selecionado-nao-e-um-json'));
        this.$refs.myFile.value = "";
        this.fileName = "Nenhum arquivo selecionado";
        return;
      }

      let reader = new FileReader();

      reader.readAsText(file, "UTF-8");

      reader.onload = (evt) => {
        try {
          this.jsonLoaded = JSON.parse(evt.target.result);
        } catch (e) {
          console.log(e);
        }

        if (
          !this.jsonLoaded.area ||
          !this.jsonLoaded.configuration
        ) {
          showError(this.$t('este-json-nao-possui-os-atributos-corretos'));
          this.$refs.myFile.value = "";
          this.fileName = "Nenhum arquivo selecionado";
          return;
        }
        this.areaSelected = this.areaSelected ? this.areaSelected : this.jsonLoaded.area
        this.saveFlowchartLoaded();
        let area = this.areaSelected
        defaultSuccess(this.$t('importando-area'))
        setTimeout(() => {
          SingletonFlowchart.loadDatabaseNodes(area)
        }, 2000)

        this.$bvModal.hide("importExport");
        this.areaSelected = "";
      };
      reader.onerror = (evt) => {
        console.error(evt);
        showError(this.$t('falha-ao-carregar-o-json'));
      };
    },

    selectedArea(area) {
      this.areaSelected = area;
    },

    async saveFlowchartLoaded() {
      let flowchart = {
        area: this.areaSelected,
        configuration: this.jsonLoaded.configuration,
      };

      if (this.saveFlowchart(flowchart)) {
        SingletonFlowchart.wasModified = false;
        defaultSuccess(this.$t('diagrama-salvo-com-sucesso'));
      }
    },

    async saveFlowchart(flowchart) {
      let success = false;
      const url = `${urlMainAPI}/saveflowchart/${this.type}`;

      await axios.post(url, flowchart)
        .then((res) => {
          if (res.status == 200)
            success = true;
          SingletonAreas.UpdateArea(flowchart)
        })
        .catch(console.log);

      return success;
    },

    exportArea() {
      this.areas.forEach((areaflowchart) => {
        if (areaflowchart.area == this.areaSelected) {
          areaflowchart = JSON.stringify(areaflowchart, null, "\t");
          let flowchartarea = new Blob([areaflowchart], {
            type: "json;charset=utf-8",
          });
          saveAs(flowchartarea, this.areaSelected + ".json");
          this.areaSelected = "";
          this.$bvModal.hide("importExport");
          defaultSuccess(this.$t('este-arquivo-foi-salvo-em-downloads'));
        }
      });
    },

    closeImportExport() {
      this.areaSelected = "";
      this.$bvModal.hide("importExport");
    },
  },
}
</script>

<style scoped></style>